<template>
    <div>
        <CFTitle title="27. Buget - Câmp de intervenție"></CFTitle>
        <div class="camp-interventie">
            <table>
                <thead>
                    <tr>
                        <th class="table-head blue-head" style="width: 33.3%"><p>Categorie câmp de intervenție</p></th>
                        <th class="table-head blue-head" style="width: 33.3%"><p>Buget</p></th>
                        <th class="table-head blue-head" style="width: 33.3%"><p>% din totalul bugetului</p></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="width: 33.3%;" class="first-in-row">001. Investiții productive generice în întreprinderi mici și mijlocii (denumite în continuare "IMM-uri")
                            pentru activitățile care nu contribuie la obiectivele de mediu</td>
                        <td style="width: 33.3%">{{ bugetData && bugetData.total && bugetData.environment_percentage ? calculateBudget('rest').toFixed(2) : 0 }} LEI</td>
                        <td style="width: 33.3%">{{ bugetData && bugetData.environment_percentage ? (100 - bugetData.environment_percentage).toFixed(0) : 0 }}%</td>
                    </tr>
                    <tr>
                        <td style="width: 33.3%;" class="first-in-row">069. Sprijinirea proceselor de producție ecologice și utilizarea eficientă a resurselor în IMM-uri
                            pentru activitățile care contribuie la obiectivele de mediu</td>
                        <td style="width: 33.3%">{{ bugetData && bugetData.total && bugetData.environment_percentage ? calculateBudget('mediu').toFixed(2) : 0 }} LEI</td>
                        <td style="width: 33.3%">{{ bugetData && bugetData.environment_percentage ? bugetData.environment_percentage.toFixed(0) : 0 }}%</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";

    export default {
        components: {
            CFTitle
        },
        props: {
            bugetData: null
        },
        data() {
            return {

            }
        },
        mounted() {
            this.$store.dispatch('finantare/addToProgress', 'Buget - Câmp de intervenție')
        },
        methods: {
            calculateBudget(type){
                if(this.bugetData){
                    if(type === 'mediu'){
                        return this.bugetData.total.RON * (Number(this.bugetData.environment_percentage) / 100)
                    } else {
                        return this.bugetData.total.RON - (this.bugetData.total.RON * (Number(this.bugetData.environment_percentage) / 100))
                    }
                }
            }
        }
    }
</script>
<style scoped>
.first-in-row {
  text-align: left;
  padding: 5px 10px;
}
.camp-interventie{
  margin-top: 40px;
}
table, th, td {
  border: 1px solid #979696;
  width: 100%;
  height: 100%;
  text-align: center;
}
td{
  font-size: 14px;
  padding: 5px;
}
.padding-td tr td:first-child{
  padding: 10px;
}
.table-head p{
  font-size: 14px;
  text-align: center;
  font-weight: 700;
  text-transform: uppercase;
}
.table-head{
  padding: 10px;
  border: 1px solid #979696;
  border-bottom: 0;
  position: relative;
}
.blue-head{
  background: #bdd6ee;
}
</style>
